const getTenth2FrameName = (originalImageUrl) => {
    const allowedImages = ['jpg', 'png', 'gif'];
    const defaultImage = '.fjpg';
    for (let i = 0; i < allowedImages.length; i++) {
        const lastElement = originalImageUrl.split('.').pop();

        if (lastElement === allowedImages[i]) {
            return `.f${allowedImages[i]}`;
        }
    }
    return defaultImage;
};

const internalThumbnail = (thumbnailDomain, imageUrl, format) => {
    if (!imageUrl) {
        return '';
    }

    return `//${thumbnailDomain}/thumb/${format}${getTenth2FrameName(imageUrl)}/?fname=${imageUrl}`;
};

export const thumbnail = (imageUrl, format) => {
    if (!imageUrl) {
        return '';
    }

    let thumbnailDomain = 'img1.daumcdn.net';

    if (imageUrl.indexOf('sandbox.kakaocdn.net') >= 0) {
        thumbnailDomain = 'img1-sandbox.kakaocdn.net';
    }

    return internalThumbnail(thumbnailDomain, imageUrl, format);
};
